import { CircularProgress, Stack } from "@mui/material";

const Loader = ({ text }) => (
  <Stack alignItems="center" justifyContent="center" height="100vh" rowGap={2}>
    <CircularProgress />
    <span>{text ?? "Loading"}</span>
  </Stack>
);

const MiniLoader = () => (
  <Stack direction="row" alignItems="center" justifyContent="center" height="100%" rowGap={2}>
    <CircularProgress size="md" />
  </Stack>
);

export { Loader, MiniLoader };
